class PasswordResetService {
  constructor(config, $http) {
    this.config  = config;
    this.$http = $http;
  }

  resetPassword(newPassword) {
    let url  = this.config.apiRoot + '/resetPassword';

    return this.$http.post(url, { newPassword: newPassword });
  }
}

PasswordResetService.$inject = ['config', '$http'];

export
default PasswordResetService;



// WEBPACK FOOTER //
// ./app/common/passwordResetService/passwordResetService.service.js